// extracted by mini-css-extract-plugin
export default {"reply":"style--reply--5ab0c5","label":"style--label--edeba9","textarea":"style--textarea--96b286","guidelines":"style--guidelines--9886e1"};